import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Red_Round_Btn.css'

const Red_Round_Btn = ({ btnText, onClick , type = "button" }) => {
    return (
        <section className="Red_Round_Btn_holder" >
            <Button className="Red_Round_Btn" type={type} onClick={onClick}>{btnText}</Button>
        </section>

    )
}

export default Red_Round_Btn
